/* eslint-disable react-hooks/exhaustive-deps */
import FamiliarSvg from "assets/img/mex/accidentesPersonales/p-familiar.png";
import InvidualSvg from "assets/img/mex/accidentesPersonales/p-individual.png";
import classNames from "classnames";
import Breadcrumcomponent from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import SiNoInputContainer from "components/InputsMex/containers/SiNoInputContainer";
import { TextInput } from "components/InputsMex/inputs";
import MisDatosForm from "components/MisDatosForm";
import Page from "components/Page";
import { ALBERT_EVENTS } from "constants/albert_events";
import {
  ambienteAplicacion,
} from "constants/urls";
import { useNavbarContext } from "contexts/NavbarContext";
import useAlbert from "hooks/useAlbert";
import withValidarRecuperar from "HOC/withValidarRecuperar";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { setBanderaPrimerPago } from "redux/actions/cotizacion.actions";
import useParametrosPago from "redux/hooks/useParametrosPago";
import { PASOS_BREADCRUMBS, PRODUCTOS } from "utils/constants";
import Loading from "wrappers/Loading";
import "./styles.scss";
import { URLS_PHP_8 } from "constants/urls_v2";
import { ApiKeyFetch } from "api/fetchers/apiKey";

const edadRules = {
  required: "Es necesario especificar una edad",
  min: { value: 18, message: "La edad mínima es de 18 años" },
  max: { value: 70, message: "La edad máxima es de 70 años" },
};
const numHijosRules = {
  required: {
    value: true,
    message: "Es es necesario especificar el número de hijos",
  },
  min: { value: 1, message: "Se debe especificar al menos un hijo" },
};

const SeleccionarTipoContainer = ({
  history,
  params: { idCotizacion },
  dataUsuario,
  addWarningToast,
}) => {
  useNavbarContext(PRODUCTOS.APINDIVIDUAL);
  const methods = useForm({ mode: "onChange" });
  const { handleSubmit, reset } = methods;
  const [paquete, setPaquete] = useState("individual");
  const [loading, setLoading] = useState(true);
  const [validaciones, setValidaciones] = useState({});
  const [catalogo, setCatalogo] = useState({});

  const { cliCodigoCore } = dataUsuario;

  const { fetchParametros } = useParametrosPago(PRODUCTOS.APINDIVIDUAL);
  const { addApEvent } = useAlbert();
  const dispatch = useDispatch();

  const getData = async () => {
    setLoading(true);

    const body = {
      datosCotizador: {
        prodCodigo: PRODUCTOS.APINDIVIDUAL,
        catPasoCodigo: "validaciones",
        usuCotiza: {
          usuCodigo: cliCodigoCore || "",
        },
      },
    };

    const { transaccion, catalogo } = await ApiKeyFetch.instance().post(URLS_PHP_8.cotizacion.catalogosCotizador, body);

    if (transaccion) {
      setCatalogo(catalogo);
      setValidaciones({ ...catalogo.edadNumero });
      // dispatch(setBanderaPrimerPago(catalogo?.banderaPrimerPago || false));
    }

    if (idCotizacion) {
      const DataResumen = {
        cotDatos: {
          ambiente: ambienteAplicacion,
          cotCodigo: idCotizacion,
        },
      };

      const resResumen = await ApiKeyFetch.instance().post(URLS_PHP_8.cotizacion.resumenCotizacion, DataResumen);

      if (resResumen.transaccion && resResumen.cotConsulta) {
        const { carContratante, carAsesor } = resResumen.cotConsulta;
        const { datosPlan } = carContratante;
        delete carContratante.datosPlan;
        setPaquete(datosPlan.paqueteSelecionado);
        const { codigoAgente } = carAsesor;
        const agente = catalogo?.permisos?.agentes?.find?.(
          (agente) => agente.codigoAgente === codigoAgente
        );
        reset({
          datosProducto: {
            ...datosPlan,
          },
          datosCliente: {
            ...carContratante,
          },
          agente,
        });
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchParametros();
    getData();
  }, []);

  const onSubmit = async (formData) => {
    const data = { ...formData };
    data.datosProducto.paqueteSelecionado = paquete;

    data.datosProducto = {
      ...data.datosProducto,
      numHijos: data.datosProducto.numHijos || "",
      edadConyugue: data.datosProducto.edadConyugue || "",
      incluirHijos: data.datosProducto.incluirHijos || false,
      incluirConyugue: data.datosProducto.incluirConyugue || false,
    };

    if (
      paquete === "familiar" &&
      data.datosProducto.numHijos === "" &&
      data.datosProducto.edadConyugue === ""
    ) {
      addWarningToast("Para el paquete familiar debe incluir al menos al cónyuge o a un hijo");
      return;
    }

    setLoading(true);

    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: "APINDIVIDUAL",
      pasoCodigo: "informacionCliente",
      items: {
        cotCodigo: idCotizacion || "",
        usuCotiza: {
          usuCodigo: cliCodigoCore || "",
        },
        ...data,
      },
    };

    const res = await ApiKeyFetch.instance().post(URLS_PHP_8.cotizacion.actualizarCotizacion, Data);

    if (res?.transaccion) {
      addApEvent(ALBERT_EVENTS.GET_QUOTE);
      history.replace(`/accidentes-personas/${res?.id}`);
      history.push(`/accidentes-planes-personas/${res.id}`);
    } else {
      try {
        res.errorDescripcion.forEach(addWarningToast);
      } catch (error) {
        addWarningToast("Ha ocurrido un problema al guardar la información");
      }
      methods.reset(formData);
    }

    setLoading(false);
  };

  const onClickPaquete = (paquete) => () => {
    setPaquete(paquete);
  };

  const processValidacion = (principal, secundaria, defaultValidacion) => {
    if (validaciones[principal]) {
      return { ...validaciones[principal] };
    } else if (validaciones[secundaria]) {
      return { ...validaciones[secundaria] };
    } else {
      return { ...defaultValidacion };
    }
  };

  return (
    <Loading loading={loading}>
      <div className='cr-content'>
        <Page>
          <Breadcrumcomponent
            title='Cotización Accidentes Personales'
            subtitle='Cotización Accidentes Personales'
          />

          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[PRODUCTOS.APINDIVIDUAL].breadCrumbPasosCotizacion[1]}
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.APINDIVIDUAL]?.pasosCotizacion}
          />

          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className='row justify-content-center'>
                <div className='col-11 col-lg-7'>
                  <div className='py-4'>
                    <h3 className='font-mex text-mex text-center' style={{ fontSize: "30px" }}>
                      ¿Qué tipo de plan necesitas?
                    </h3>

                    <div className='row mt-4'>
                      <div className='col-md-6 '>
                        <div className='row text-center mb-2'>
                          <div
                            className='col-12 p-4 cpointer'
                            onClick={onClickPaquete("individual")}>
                            <img
                              className={classNames({
                                "container-paquete": true,
                                selected: paquete === "individual",
                              })}
                              src={InvidualSvg}
                              alt=''
                            />
                            <h4 className='font-mex text-center'>Paquete individual</h4>
                          </div>
                        </div>

                        {paquete === "individual" && (
                          <div className='form-group'>
                            <SimpleContainer name='datosProducto.edad' label='Edad' subLabel='Años'>
                              <TextInput
                                inputProps={{
                                  name: "datosProducto.edad",
                                  isNumberInt: true,
                                }}
                                hideArrows
                                rules={processValidacion(
                                  "prodEdadPindividualRules",
                                  "prodEdadRules",
                                  edadRules
                                )}
                              />
                            </SimpleContainer>
                          </div>
                        )}
                      </div>

                      <div className='col-md-6'>
                        <div className='row text-center mb-2'>
                          <div
                            className='col-12 p-4 h-100 cpointer'
                            onClick={onClickPaquete("familiar")}>
                            <img
                              className={classNames({
                                "container-paquete": true,
                                selected: paquete === "familiar",
                              })}
                              src={FamiliarSvg}
                              alt=''
                            />
                            <h4 className='font-mex'>Paquete familiar</h4>
                          </div>
                        </div>

                        {paquete === "familiar" && (
                          <React.Fragment>
                            <div className='form-group'>
                              <SimpleContainer
                                label='Edad'
                                name='datosProducto.edad'
                                subLabel='Años'>
                                <TextInput
                                  inputProps={{
                                    name: "datosProducto.edad",
                                    isNumberInt: true,
                                  }}
                                  hideArrows
                                  rules={processValidacion(
                                    "prodEdadPfamiliarRules",
                                    "prodEdadRules",
                                    edadRules
                                  )}
                                />
                              </SimpleContainer>
                            </div>

                            <div className='form-group'>
                              <SiNoInputContainer
                                label='¿Deseas incluir a tu cónyuge?'
                                name='datosProducto.edadConyugue'
                                subLabel='Años'
                                btnName='datosProducto.incluirConyugue'>
                                <TextInput
                                  inputProps={{
                                    name: "datosProducto.edadConyugue",
                                    isNumberInt: true,
                                  }}
                                  hideArrows
                                  rules={processValidacion(
                                    "prodEdadConyugeRules",
                                    "prodEdadRules",
                                    edadRules
                                  )}
                                />
                              </SiNoInputContainer>
                            </div>

                            <div className='form-group'>
                              <SiNoInputContainer
                                label='¿Deseas incluir a tus hijos?'
                                name='datosProducto.numHijos'
                                helpText='Solo se permiten hijos dependientes económicos del asegurado titular, desde los 6 meses a los 24 años'
                                btnName='datosProducto.incluirHijos'>
                                <TextInput
                                  inputProps={{
                                    name: "datosProducto.numHijos",
                                    isNumberInt: true,
                                    defaultValue: 1,
                                  }}
                                  hideArrows
                                  rules={processValidacion(
                                    "prodNumHijosRules",
                                    "prodNumHijosRules",
                                    numHijosRules
                                  )}
                                />
                              </SiNoInputContainer>
                            </div>
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-11 col-md-5 col-lg-5'>
                  <MisDatosForm
                    methods={methods}
                    inputs={["usuCorreo", "usuNombre", "usuTelefono", "disclaimerTerminos"]}
                    overrideInputs={catalogo && catalogo.urlTerminosCondiciones}
                    usuTelefonoProps={{ keyfilter: "int", maxLength: 10 }}
                    clavesAgente={catalogo?.permisos?.agentes}
                  />
                </div>
              </div>
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};

export default withValidarRecuperar(SeleccionarTipoContainer);
